export function formatNameWithPronouns(name: string, pronouns?: string): string {
  return [
    name,
    pronouns ? `(${pronouns})` : '',
  ].filter(Boolean).join(' ');
}
